import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/img_close_black.png'


const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "sub-title" }

import { computed, nextTick, ref, toRefs, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
	visible: {
		type: Boolean,
		default: () => false,
	},
	innerStyle: {
		type: Object,
		default: () => ({}),
	},
	innerClass: {
		type: String,
		defualt: () => '',
	},
	title: {
		type: String,
		default: () => '',
	},
	subTitle: {
		type: String,
		default: () => '',
	},
	showClose: {
		type: Boolean,
		default: () => true,
	},
},
  emits: ['afterShow', 'afterHide', 'hide', 'update:visible'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { visible, innerStyle } = toRefs(props); // 弹框组件显隐
const wrapperVisible = ref(false); // 弹框外部容器显隐
const innerVisible = ref(false); // 弹框中间容器显隐

watch(visible, val => {
	if (val) {
		wrapperVisible.value = true;
		setTimeout(() => {
			innerVisible.value = true;
			emit('afterShow');
		}, 100);
	} else {
		innerVisible.value = false;
		setTimeout(() => {
			wrapperVisible.value = false;
			emit('afterHide');
		}, 100);
	}
});
function hide() {
	emit('update:visible', false);
	emit('hide');
}

const containerStyle = computed(() => ({
	transform: innerVisible.value
		? 'translate(-50%, -70%) scale(1,1)'
		: 'translate(-50%, -70%) scale(0,0)',
	...innerStyle.value,
}));

function clickMask() {
	hide();
}

return (_ctx: any,_cache: any) => {
  return (wrapperVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "global-modal",
        onClick: clickMask
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['global-modal-container', __props.innerClass]),
          style: _normalizeStyle(containerStyle.value),
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.subTitle), 1),
          (__props.showClose)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "close-icon",
                src: _imports_0,
                onClick: hide
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ], 6)
      ]))
    : _createCommentVNode("", true)
}
}

})